export enum ProgressStatus {
  RUNNING = 'running',
  COMPLETED = 'completed',
}
